export default __webpack_public_path__ + "static/float_gradation_pc-dca2088200a62159e317e346cb940311.png";